import {
  LayoutGrid,
  Layers,
  Bell,
  Settings,
  MessageCircleMore,
  BookOpen,
  MessageSquare
} from 'lucide-react'

export const menuItems = [
  { icon: <LayoutGrid color="currentColor" strokeWidth={1} />, text: "Dashboard", href: '/' },
  { icon: <Layers color="currentColor" strokeWidth={1} />, text: "Catalog", href: '/catalog' },
  { icon: <Bell color="currentColor" strokeWidth={1} />, text: "Notifications", href: '/notifications' },
  { icon: <Settings color="currentColor" strokeWidth={1} />, text: "Settings", href: "/settings" },
  { icon: <MessageCircleMore color="currentColor" strokeWidth={1} />, text: "All Chats", href: "/allchat" },
  { icon: <MessageSquare color="currentColor" strokeWidth={1} />, text: "All Discussions", href: "/alldiscussion", adminOnly: true },
  { icon: <BookOpen color="currentColor" strokeWidth={1} />, text: "Help Center", href: "/help-center" },
];